<template>
  <BaseDialog
    ref="baseDialog"
    modal-id="processMonthlyDialog"
    :title="$t('salary_management.process_monthly')"
    :confirm-text="$t('salary_management.process')"
    confirm-variant="primary"
    size="lg"
    @confirm="handleConfirm"
  >
    <template #body>
      <div class="row">
        <div class="col-md-6">
          <label class="form-label">{{ $t('salary_management.month') }} *</label>
          <input
            type="month"
            class="form-control"
            v-model="formData.month"
            :class="{ 'is-invalid': errors.month }"
            required
          />
          <div class="invalid-feedback">{{ errors.month }}</div>
        </div>
        <div class="col-md-6">
          <label class="form-label">{{ $t('salary_management.description') }}</label>
          <textarea
            class="form-control"
            v-model="formData.description"
            rows="3"
            :placeholder="$t('salary_management.monthly_description_placeholder')"
          ></textarea>
        </div>
      </div>
      <div class="mt-3">
        <p class="text-info small">
          <i class="fas fa-info-circle me-1"></i>
          {{ $t('salary_management.monthly_process_note') }}
        </p>
      </div>
    </template>
  </BaseDialog>
</template>

<script setup>
import { ref, defineEmits, defineExpose } from 'vue';
import { useI18n } from 'vue-i18n';
import BaseDialog from '@/components/common/BaseDialog.vue';

const { t } = useI18n();
const baseDialog = ref(null);
const emit = defineEmits(['process']);

const formData = ref({
  month: '',
  description: ''
});

const errors = ref({});

const open = () => {
  formData.value = {
    month: new Date().toISOString().slice(0, 7),
    description: ''
  };
  errors.value = {};
  baseDialog.value?.openDialog();
};

const handleConfirm = () => {
  if (!validateForm()) {
    return;
  }
  emit('process', formData.value);
  baseDialog.value?.closeDialog();
};

const validateForm = () => {
  errors.value = {};
  
  if (!formData.value.month) {
    errors.value.month = t('validation.required');
    return false;
  }

  return true;
};

defineExpose({ open });
</script>